import type { WidgetTableProps } from '@/components/WidgetTable/types';
import { RelativeTimeWithTooltip } from '@/components/shared/RelativeTimeWithTooltip';

export type AIToolUser = {
  userId: string;
  email: string | null;
  name: string | null;
  machineId: string;
  timestamp: string;
};

export const COLUMNS: WidgetTableProps<AIToolUser>['columns'] = [
  {
    header: 'User',
    id: 'user',
    cell: user => {
      const displayName = user.name || user.email || user.userId;
      return (
        <span
          className="font-medium truncate block max-w-[200px]"
          title={displayName}
        >
          {displayName}
        </span>
      );
    },
    className: 'min-w-[150px]',
  },
  {
    header: 'Email',
    id: 'email',
    cell: user => (
      <span className="text-sm text-muted-foreground">{user.email || '—'}</span>
    ),
    className: 'min-w-[180px]',
  },
  {
    header: 'Last Seen',
    id: 'lastSeen',
    cell: user => <RelativeTimeWithTooltip date={user.timestamp} />,
    className: 'min-w-[120px]',
  },
];
